// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"99b16bb4","496":"c361039b"}[chunkId] + ".chunk.js";
};